import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  id: "Nav",
  class: "left"
}
const _hoisted_3 = { class: "back" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "maintitle s60" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = {
  class: "cta secondary s16",
  "data-color": "white"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  class: "cta secondary s16",
  "data-color": "white"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  id: "Main",
  class: "right"
}
const _hoisted_14 = {
  class: "logo",
  "data-color": "cyan50"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = ["alt"]
const _hoisted_17 = { class: "intro" }
const _hoisted_18 = { class: "maintitle s36" }
const _hoisted_19 = {
  ref: "form",
  class: "form"
}
const _hoisted_20 = {
  key: 0,
  class: "group"
}
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { for: "Name" }
const _hoisted_23 = ["aria-label", "placeholder"]
const _hoisted_24 = { class: "item" }
const _hoisted_25 = ["aria-label", "placeholder"]
const _hoisted_26 = {
  key: 1,
  class: "item"
}
const _hoisted_27 = { for: "Name" }
const _hoisted_28 = { class: "group" }
const _hoisted_29 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_30 = ["for"]
const _hoisted_31 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_32 = { for: "ProfileSegment" }
const _hoisted_33 = { value: null }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "item" }
const _hoisted_36 = { for: "Country" }
const _hoisted_37 = { value: null }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "group" }
const _hoisted_40 = { class: "item" }
const _hoisted_41 = { for: "Address" }
const _hoisted_42 = ["aria-label"]
const _hoisted_43 = { class: "item" }
const _hoisted_44 = ["aria-label"]
const _hoisted_45 = { class: "item" }
const _hoisted_46 = { for: "TaxCode" }
const _hoisted_47 = { class: "group" }
const _hoisted_48 = { class: "item" }
const _hoisted_49 = { for: "PostCode" }
const _hoisted_50 = ["aria-label"]
const _hoisted_51 = { class: "item" }
const _hoisted_52 = ["aria-label"]
const _hoisted_53 = { value: null }
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "group" }
const _hoisted_56 = { class: "item" }
const _hoisted_57 = { for: "IVACode" }
const _hoisted_58 = ["aria-label"]
const _hoisted_59 = { class: "item" }
const _hoisted_60 = ["aria-label"]
const _hoisted_61 = { value: null }
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "group" }
const _hoisted_64 = { class: "item" }
const _hoisted_65 = { for: "SDICode" }
const _hoisted_66 = ["aria-label"]
const _hoisted_67 = { class: "item" }
const _hoisted_68 = ["aria-label"]
const _hoisted_69 = {
  class: "group",
  "data-type": "phone"
}
const _hoisted_70 = { class: "item" }
const _hoisted_71 = { for: "PhonePrefix" }
const _hoisted_72 = ["aria-label"]
const _hoisted_73 = { class: "item" }
const _hoisted_74 = ["aria-label"]
const _hoisted_75 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_76 = { class: "cta" }

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountProfileEdit',
  props: {
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const formHelper = FormHelper;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const provinces = ref<any[]>([]);
const profileTaxTypes = ref<any[]>([]);
const countries = ref<any[]>([]);
const activityTypes = ref<any[]>([]);
const editData = ref<any>(null);
const formData = ref<any>({ province: null, profileTaxType: null, country: null, activityType: null, profileSegment: null });
const validationErrors = ref<any[]>([]);
const isCompany = ref(false);
const isItalyCountry = ref(false);
const profileSegments = ref<any[]>([]);

onBeforeMount(async () => {
    await getData();
});

async function getData() {
    editData.value = (await Axios.post(routes.Account_Profile_GetEditData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    formData.value.name = editData.value.name;
    formData.value.surname = editData.value.surname;
    formData.value.address = editData.value.address;
    formData.value.city = editData.value.city;
    formData.value.postCode = editData.value.postCode;
    formData.value.province = editData.value.province == "" ? null : editData.value.province;
    formData.value.country = editData.value.country == "" ? null : editData.value.country;
    formData.value.profileTaxType = editData.value.profileTaxType == "" ? "Persona fisica" : editData.value.profileTaxType;
    formData.value.taxCode = editData.value.taxCode;
    formData.value.ivaCode = editData.value.ivaCode;
    formData.value.sdiCode = editData.value.sdiCode;
    formData.value.certifiedEmail = editData.value.certifiedEmail;
    formData.value.activityType = editData.value.activityType == "" ? null : editData.value.activityType;
    formData.value.phoneNumber = editData.value.phoneNumber;
    formData.value.profileSegment = editData.value.profileSegment == "" ? null : editData.value.profileSegment;
    provinces.value = editData.value.provinces;
    profileTaxTypes.value = editData.value.profileTaxTypes;
    countries.value = editData.value.countries;
    activityTypes.value = editData.value.activityTypes;
    profileSegments.value = editData.value.profileSegments;
    onProfileTaxTypeChanged();
    onCountryChanged();
}

function onProfileTaxTypeChanged() {
    isCompany.value = formData.value.profileTaxType === "Persona giuridica";
    if (isCompany.value) {
        formData.value.surname = null;
    } else {
        formData.value.ivaCode = null;
        formData.value.activityType = null;
        formData.value.sdiCode = null;
        formData.value.certifiedEmail = null;
    }
}

function onCountryChanged() {
    if (formData.value.country === "IT") {
        isItalyCountry.value = true;
    } else {
        isItalyCountry.value = false;
        formData.value.province = null;
    }
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoading.value = true;

    try {
        let result = (await Axios.post(routes.Account_Profile_Edit, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        isSuccess.value = true;
        window.location.href = result.redirectUrl ? result.redirectUrl : (props.returnUrl ? props.returnUrl : "/");
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function goBack() {
    props.returnUrl ? window.location.href = props.returnUrl : history.back();
}

return (_ctx: any,_cache: any) => {
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
          class: "button icon fastic-circle-left",
          "aria-label": _unref(localizer).get('App.Common.PageBack')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(localizer).get("Account.Edit.EditProfileTitle")), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(localizer).get("Account.Edit.EditProfileDesc")), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", {
              href: _unref(routes).MyBeghelliProfile_AccountEdit,
              class: "button"
            }, _toDisplayString(_unref(localizer).get("Account.Common.AccountSecurity")), 9, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              href: _unref(routes).Account_Profile_Edit,
              class: "button selected"
            }, _toDisplayString(_unref(localizer).get("Account.Common.PersonalData")), 9, _hoisted_12)
          ])
        ])
      ]),
      _createVNode(_component_app_footer)
    ]),
    _createElementVNode("main", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("a", {
          href: _unref(routes).Home
        }, [
          _createElementVNode("img", {
            src: "/images/logo.svg",
            width: "125",
            height: "35",
            alt: _unref(localizer).get('App.Common.Beghelli')
          }, null, 8, _hoisted_16)
        ], 8, _hoisted_15)
      ]),
      (editData.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onKeydown: _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
            class: "content"
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h2", _hoisted_18, _toDisplayString(_unref(localizer).get("Account.Edit.UpdateDataProfile")), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("fieldset", null, [
                (!isCompany.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(localizer).get("App.Form.NameSurname")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "aria-label": _unref(localizer).get('App.Form.Name'),
                          id: "Name",
                          placeholder: _unref(localizer).get('App.Form.NamePlaceholder'),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Name', validationErrors.value) }, 'input w300'])
                        }, null, 10, _hoisted_23), [
                          [
                            _vModelText,
                            formData.value.name,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "aria-label": _unref(localizer).get('App.Form.Surname'),
                          id: "Surname",
                          placeholder: _unref(localizer).get('App.Form.SurnamePlaceholder'),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.surname) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Surname', validationErrors.value) }, 'input w300'])
                        }, null, 10, _hoisted_25), [
                          [
                            _vModelText,
                            formData.value.surname,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(localizer).get("Account.User.Company")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "Name",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.name) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Name', validationErrors.value) }, 'input w300'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.name,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ]))
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileTaxTypes.value, (profileTaxType, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "radio"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "profileTaxType",
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (onProfileTaxTypeChanged())),
                        id: profileTaxType.value,
                        value: profileTaxType.value,
                        "onUpdate:modelValue": ($event: any) => ((formData.value.profileTaxType) = $event)
                      }, null, 40, _hoisted_29), [
                        [_vModelRadio, formData.value.profileTaxType]
                      ]),
                      _createElementVNode("label", {
                        for: profileTaxType.value
                      }, _toDisplayString(profileTaxType.title), 9, _hoisted_30)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(localizer).get("App.Common.AddFunctionalities")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "ProfileSegment",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.profileSegment) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('ProfileSegment', validationErrors.value) }, 'input w460'])
                  }, [
                    _createElementVNode("option", _hoisted_33, _toDisplayString(_unref(localizer).get("App.Form.Select")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileSegments.value, (profileSegment, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: profileSegment.value,
                        key: index
                      }, _toDisplayString(profileSegment.title), 9, _hoisted_34))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, formData.value.profileSegment]
                  ])
                ])
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(localizer).get("Account.User.Country")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "Country",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.country) = $event)),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (onCountryChanged())),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Country', validationErrors.value) }, 'input w300'])
                  }, [
                    _createElementVNode("option", _hoisted_37, _toDisplayString(_unref(localizer).get("App.Form.Select")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: country.value,
                        key: index
                      }, _toDisplayString(country.title), 9, _hoisted_38))
                    }), 128))
                  ], 34), [
                    [_vModelSelect, formData.value.country]
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(localizer).get("App.Form.AddressLocation")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "aria-label": _unref(localizer).get('App.Form.Address'),
                      id: "Address",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.address) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Address', validationErrors.value) }, 'input w300'])
                    }, null, 10, _hoisted_42), [
                      [
                        _vModelText,
                        formData.value.address,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "aria-label": _unref(localizer).get('App.Form.Location'),
                      id: "City",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.city) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('City', validationErrors.value) }, 'input w300'])
                    }, null, 10, _hoisted_44), [
                      [
                        _vModelText,
                        formData.value.city,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(localizer).get("App.Common.TaxCode")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "TaxCode",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.taxCode) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('TaxCode', validationErrors.value) }, 'input w300'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.taxCode,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(localizer).get("App.Form.PostCodeProvince")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "aria-label": _unref(localizer).get('App.Form.PostCode'),
                      id: "PostCode",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.postCode) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('PostCode', validationErrors.value) }, 'input w300'])
                    }, null, 10, _hoisted_50), [
                      [
                        _vModelText,
                        formData.value.postCode,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _withDirectives(_createElementVNode("select", {
                      id: "Province",
                      "aria-label": _unref(localizer).get('App.Form.Province'),
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.province) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Province', validationErrors.value) }, 'input w300'])
                    }, [
                      _createElementVNode("option", _hoisted_53, _toDisplayString(_unref(localizer).get("App.Form.Select")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinces.value, (province, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: province.value,
                          key: index
                        }, _toDisplayString(province.title), 9, _hoisted_54))
                      }), 128))
                    ], 10, _hoisted_52), [
                      [_vModelSelect, formData.value.province]
                    ])
                  ])
                ]),
                (isCompany.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(localizer).get("App.Form.VATCodeActivity")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "aria-label": _unref(localizer).get('App.Form.VATCode'),
                            id: "IVACode",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.ivaCode) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('IVACode', validationErrors.value) }, 'input w300'])
                          }, null, 10, _hoisted_58), [
                            [
                              _vModelText,
                              formData.value.ivaCode,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _withDirectives(_createElementVNode("select", {
                            id: "ActivityType",
                            "aria-label": _unref(localizer).get('App.Form.Activity'),
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.activityType) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('ActivityType', validationErrors.value) }, 'input w300'])
                          }, [
                            _createElementVNode("option", _hoisted_61, _toDisplayString(_unref(localizer).get("App.Form.Select")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityTypes.value, (activityType, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: activityType.value,
                                key: index
                              }, _toDisplayString(activityType.title), 9, _hoisted_62))
                            }), 128))
                          ], 10, _hoisted_60), [
                            [_vModelSelect, formData.value.activityType]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("label", _hoisted_65, _toDisplayString(_unref(localizer).get("App.Form.SDICode_PEC")), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "aria-label": _unref(localizer).get('App.Form.SDICode'),
                            id: "SDICode",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.sdiCode) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('SDICode', validationErrors.value) }, 'input w300'])
                          }, null, 10, _hoisted_66), [
                            [
                              _vModelText,
                              formData.value.sdiCode,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            "aria-label": _unref(localizer).get('App.Form.CertifiedEmail'),
                            id: "CertifiedEmail",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.certifiedEmail) = $event)),
                            class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('CertifiedEmail', validationErrors.value) }, 'input w300'])
                          }, null, 10, _hoisted_68), [
                            [
                              _vModelText,
                              formData.value.certifiedEmail,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(localizer).get("App.Form.Phone")), 1),
                    _createElementVNode("input", {
                      type: "text",
                      disabled: "",
                      "aria-label": _unref(localizer).get('App.Form.PhonePrefix'),
                      id: "PhonePrefix",
                      class: "input w55",
                      value: "+39"
                    }, null, 8, _hoisted_72)
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "aria-label": _unref(localizer).get('App.Form.PhoneNumber'),
                      id: "PhoneNumber",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.phoneNumber) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('PhoneNumber', validationErrors.value) }, 'input w240'])
                    }, null, 10, _hoisted_74), [
                      [
                        _vModelText,
                        formData.value.phoneNumber,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("fieldset", null, [
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{ 'loading': isSuccess.value }, 'button']),
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (submitForm()))
                  }, [
                    (!isSuccess.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ])
            ], 512)
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})